import type { FelicitacionStepProps } from "./config";
import IllustratedStepCard from "./IllustratedStepCard";
import step5PreviewImage from "../../../assets/images/felicitacion/step-5-mailbox.webp";

const Step5 = ({ selectedGrandpa }: FelicitacionStepProps) => {
	return (
		<IllustratedStepCard
			background="var(--icon-primary-soft, #C4E0F5)"
			cardPadding="24px 0 0 0"
			copyPadding="0 24px"
			description="No tienes que preocuparte por nada, ya tiene el sello y la dirección de envío incluidos. ¡Nosotros nos encargaremos de hacérsela llegar!"
			imageAlt={`Tarjeta con los datos de ${selectedGrandpa?.name ?? "la persona mayor"}`}
			imageAlign="flex-end"
			imageFit="cover"
			imageHeight="100%"
			imageJustify="flex-end"
			imageMarginTop="16px"
			imageMaxHeight="none"
			imageMaxWidth="100%"
			imagePosition="right bottom"
			imageSrc={step5PreviewImage}
			imageTransform="none"
			imageWidth="100%"
			title="Deposita la tarjeta en tu buzón favorito"
		/>
	);
};

export default Step5;
